import React from 'react';
import Posts from './Posts';

const KnowledgeBase = () => {
  return <Posts type="KnowledgeBase" title="Knowledge Base" />;
};

export default KnowledgeBase;
